export const CLIENT_SENDERS_ROUTE_NAME = "CLIENT_SENDERS";
export const PHONEBOOK_CONTACTS_ROUTE = "CLIENT_CONTACTS";
export const PHONEBOOK_DATA_SOURCE_ROUTE = "CLIENT_CONTACTS_DATA_SOURCE";

export const ONLINE_CHAT_DISCOUNT_COUPON_ROUTE_NAME = "ONLINE_CHAT_DISCOUNT_COUPON";
export const SITES_LICENSE_LIST = `ONLINE_CHAT_LICENSE_LIST`;

export const MARKETOLOG_ROUTE = "MARKETOLOG_ROUTE";
export const MARKETOLOG_DASHBOARD_ROUTE = `${MARKETOLOG_ROUTE}_DASHBOARD`;